
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniarentalservicepune() {



    const cardData =
    {
        keyword: 'Urbania Rental Services Pune ',
        heading: 'Amruta Travels: Urbania Rental Services Pune ',
        headingDescription: 'Amruta Travels offers Urbania Rental Services in Pune, providing premium and reliable transportation for corporate trips, family outings, school excursions, airport transfers, and weekend getaways. Our fleet of 13-seater and 17-seater Force Urbania vans features spacious interiors, air-conditioning, and modern amenities to ensure a comfortable and hassle-free journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania rental in Pune safe, convenient, and stylish for all your group travel needs.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania rental services in Pune",
    "description": "Urbania rental services in Pune with luxury interiors, AC, cushioned seating, ample luggage space, and professional drivers. Ideal for local sightseeing, corporate travel, family outings, airport transfers, and outstation trips."
  },
  {
    "name": "Force Urbania rental services Pune",
    "description": "Hire Force Urbania rental services in Pune for comfortable city travel, airport transfers, family trips, or outstation journeys. Vehicles come with AC, cushioned seating, luggage-friendly interiors, and trained drivers."
  },
  {
    "name": "Urbania van rental Pune",
    "description": "Urbania van rental in Pune for small or medium groups. Fully AC interiors, cushioned seating, luggage space, and professional drivers ensure safe, convenient, and luxurious travel for city or outstation trips."
  },
  {
    "name": "Urbania on rent in Pune",
    "description": "Urbania on rent in Pune for corporate travel, family outings, airport transfers, or weekend trips. Comfortable, AC-equipped interiors with cushioned seating, luggage space, and expert drivers for a stress-free ride."
  },
  {
    "name": "Force Urbania hire Pune",
    "description": "Force Urbania hire in Pune for executive travel, corporate events, or family trips. Luxury interiors, AC, cushioned seating, luggage-friendly, and experienced drivers ensure smooth and comfortable journeys."
  },
  {
    "name": "Urbania rental service near me Pune",
    "description": "Urbania rental service near me in Pune with fully AC interiors, cushioned seats, luggage space, and professional drivers. Ideal for city tours, airport transfers, or outstation travel."
  },
  {
    "name": "Urbania rental services Pimpri Chinchwad",
    "description": "Urbania rental services in Pimpri Chinchwad offering comfortable, AC-equipped vehicles, cushioned seating, ample luggage space, and professional drivers for city or outstation trips."
  },
  {
    "name": "13 seater Urbania rental Pune",
    "description": "13 seater Urbania rental in Pune for families, groups, or corporate travel. AC interiors, cushioned seating, ample luggage space, and professional drivers ensure a safe and comfortable journey."
  },
  {
    "name": "17 seater Urbania rental Pune",
    "description": "17 seater Urbania rental in Pune for larger groups or corporate events. AC interiors, cushioned seating, luggage-friendly design, and experienced drivers provide luxury and safety on city or outstation trips."
  },
  {
    "name": "Luxury Urbania rental Pune",
    "description": "Luxury Urbania rental in Pune with premium AC interiors, cushioned seating, ample luggage space, and trained drivers for family trips, corporate events, airport transfers, or weekend getaways."
  },
  {
    "name": "AC Urbania rental Pune",
    "description": "AC Urbania rental in Pune with comfortable cushioned seating, luggage-friendly interiors, and professional drivers for city travel, airport transfers, family outings, or long-distance trips."
  },
  {
    "name": "Force Urbania 17 seater rental Pune",
    "description": "Hire a 17 seater Force Urbania in Pune with AC interiors, spacious cushioned seating, ample luggage space, and experienced drivers for corporate events, family trips, or outstation journeys."
  },
  {
    "name": "13 seater Urbania rental Pimpri Chinchwad",
    "description": "13 seater Urbania rental in Pimpri Chinchwad for family trips, group outings, or corporate travel. AC interiors, cushioned seats, luggage-friendly, and professional drivers ensure comfort and safety."
  },
  {
    "name": "Urbania rental services in Baner Pune",
    "description": "Urbania rental services in Baner Pune with AC interiors, cushioned seating, luggage space, and professional drivers. Perfect for city tours, airport transfers, weekend getaways, and corporate travel."
  },
  {
    "name": "Urbania Bus hire services Hadapsar Pune",
    "description": "Urbania bus hire in Hadapsar Pune for family trips, corporate events, or outstation travel. Vehicles come with AC, cushioned seating, luggage-friendly interiors, and professional drivers."
  },
  {
    "name": "Urbania rental in Hinjewadi Pune",
    "description": "Urbania rental in Hinjewadi Pune with AC interiors, cushioned seating, luggage space, and professional drivers. Ideal for corporate travel, family trips, airport transfers, and city tours."
  },
  {
    "name": "Urbania Bus hire Kothrud Pune",
    "description": "Urbania bus hire in Kothrud Pune for group travel, corporate events, or family outings. AC interiors, cushioned seating, ample luggage space, and professional drivers ensure a comfortable and safe ride."
  },
  {
    "name": "Urbania rental in Wakad Pune",
    "description": "Urbania rental in Wakad Pune with AC, cushioned seating, luggage-friendly interiors, and professional drivers. Perfect for city travel, airport transfers, family trips, and weekend getaways."
  },
  {
    "name": "Urbania rental services Pune for outstation",
    "description": "Urbania rental services in Pune for outstation trips to Lonavala, Mahabaleshwar, Shirdi, or Mumbai. AC interiors, cushioned seating, ample luggage space, and professional drivers provide a safe and comfortable journey."
  },
  {
    "name": "Urbania rental Pune for corporate events",
    "description": "Urbania rental in Pune for corporate events with AC, cushioned seating, ample luggage space, and professional drivers. Ideal for conferences, meetings, employee transport, and executive travel."
  },
  {
    "name": "Urbania rental Pune for family trip",
    "description": "Urbania rental in Pune for family trips with spacious AC interiors, cushioned seating, luggage-friendly interiors, and professional drivers for safe, comfortable, and enjoyable travel."
  },
  {
    "name": "Urbania rental Pune for wedding",
    "description": "Urbania rental in Pune for wedding transport with AC interiors, cushioned seating, luggage space, and experienced drivers. Perfect for bridal parties, guests, or family groups traveling to wedding venues."
  },
  {
    "name": "Urbania rental Pune airport transfer",
    "description": "Urbania rental for Pune airport transfers with AC, cushioned seating, luggage-friendly interiors, and professional drivers ensuring timely and comfortable pickup or drop-off."
  },
  {
    "name": "Urbania rental PCMC for group travel",
    "description": "Urbania rental in PCMC for group travel with AC interiors, cushioned seating, ample luggage space, and professional drivers. Suitable for family trips, corporate outings, or weekend getaways."
  },
  {
    "name": "13 Seater Urbania Rental Services in Pune",
    "description": "13 Seater Urbania rental services in Pune for families, small groups, and corporate travel. AC interiors, cushioned seating, luggage-friendly interiors, and professional drivers provide a safe, comfortable, and enjoyable ride."
  },
  {
    "name": "Luxury Force Urbania Rental Pimpri Chinchwad",
    "description": "Luxury Force Urbania rental in Pimpri Chinchwad with AC, cushioned seating, ample luggage space, and professional drivers. Perfect for corporate travel, family outings, or weekend trips in style."
  },
  {
    "name": "Urbania Bus Rental Services Pune & PCMC",
    "description": "Urbania bus rental services in Pune & PCMC with AC interiors, cushioned seating, luggage-friendly interiors, and professional drivers. Ideal for family trips, corporate events, airport transfers, and outstation travel."
  },
  {
    "name": "Urbania rental services Pune price",
    "description": "Urbania rental services in Pune with transparent pricing for hourly, daily, and outstation trips. Vehicles include AC, cushioned seating, luggage space, and professional drivers for safe and comfortable travel."
  },
  {
    "name": "Urbania rental Pune per km rate",
    "description": "Urbania rental services in Pune with per km rates for city travel or outstation trips. AC interiors, cushioned seating, ample luggage space, and professional drivers for hassle-free travel."
  },
  {
    "name": "Affordable Urbania rental Pune",
    "description": "Affordable Urbania rental in Pune with AC, cushioned seating, luggage-friendly interiors, and professional drivers. Suitable for city tours, airport transfers, family outings, and outstation trips."
  },
  {
    "name": "Best Urbania rental services Pune",
    "description": "Best Urbania rental services in Pune offering AC, cushioned seating, ample luggage space, and professional drivers. Ideal for family trips, corporate travel, airport transfers, and weekend getaways."
  },
  {
    "name": "Cheap Urbania rental Pimpri Chinchwad",
    "description": "Cheap Urbania rental in Pimpri Chinchwad with AC, cushioned seating, luggage-friendly interiors, and professional drivers. Perfect for budget-friendly city tours, outstation travel, or group trips."
  }
],
"tableData": [
  ["Urbania rental services in Pune", "Force Urbania rental services Pune"],
  ["Urbania van rental Pune", "Urbania on rent in Pune"],
  ["Force Urbania hire Pune", "Urbania rental service near me Pune"],
  ["Urbania rental services Pimpri Chinchwad", "13 seater Urbania rental Pune"],
  ["17 seater Urbania rental Pune", "Luxury Urbania rental Pune"],
  ["AC Urbania rental Pune", "Force Urbania 17 seater rental Pune"],
  ["13 seater Urbania rental Pimpri Chinchwad", "Urbania rental services in Baner Pune"],
  ["Urbania Bus hire services Hadapsar Pune", "Urbania rental in Hinjewadi Pune"],
  ["Urbania Bus hire Kothrud Pune", "Urbania rental in Wakad Pune"],
  ["Urbania rental services Pune for outstation", "Urbania rental Pune for corporate events"],
  ["Urbania rental Pune for family trip", "Urbania rental Pune for wedding"],
  ["Urbania rental Pune airport transfer", "Urbania rental PCMC for group travel"],
  ["13 Seater Urbania Rental Services in Pune", "Luxury Force Urbania Rental Pimpri Chinchwad"],
  ["Urbania Bus Rental Services Pune & PCMC", "Urbania rental services Pune price"],
  ["Urbania rental Pune per km rate", "Affordable Urbania rental Pune"],
  ["Best Urbania rental services Pune", "Cheap Urbania rental Pimpri Chinchwad"]
],




"whychoose": [
  {
    "WhyChooseheading": "Premium Urbania Rental Services in Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania Rental Services in Pune, providing stylish, comfortable, and reliable vehicles for small to medium-sized groups. Enjoy a premium travel experience for corporate trips, family outings, or VIP transport."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and VIP Travel",
    "WhyChoosedescription": "Whether it’s a corporate event, family excursion, or VIP transportation, our Urbania Rental Services ensure spacious, comfortable, and stylish travel across Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Interiors",
    "WhyChoosedescription": "Our Urbania vehicles feature plush seating, generous legroom, air conditioning, large windows, and ample luggage space, making them perfect for day trips, long journeys, and city tours."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All rentals come with trained and courteous drivers who ensure a smooth, safe, and punctual journey. They are experienced in handling Urbania vehicles for all kinds of trips."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Affordable Luxury",
    "WhyChoosedescription": "Amruta Travels offers clear and upfront pricing with no hidden charges, providing the luxury of Urbania at competitive rates for all your travel needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized to maintain the highest standards of safety, hygiene, and comfort for all passengers."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We provide flexible scheduling, customizable travel routes, and multiple pickup/drop-off options to match your specific travel plans, whether local or outstation."
  },
  {
    "WhyChooseheading": "Easy Booking with Full Support",
    "WhyChoosedescription": "Booking an Urbania rental in Pune is simple with Amruta Travels. Our friendly support team guides you at every step, ensuring a seamless and enjoyable travel experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I rent an Urbania in Pune?',
    answer: 'Renting an Urbania in Pune is easy with Amruta Travels. You can book online, call our support team, or visit our office. We will help you choose the ideal vehicle for your group and travel needs.'
  },
  {
    question: 'What are the features of the Urbania for rental?',
    answer: 'Urbania vehicles are equipped with luxurious interiors, comfortable seating, air conditioning, large windows, ample luggage space, and modern amenities for a premium travel experience.'
  },
  {
    question: 'Is the Urbania suitable for outstation travel?',
    answer: 'Yes, the Urbania is perfect for both local and outstation trips. It provides comfort, stability, and a smooth ride for long-distance travel.'
  },
  {
    question: 'Does the Urbania rental include a driver?',
    answer: 'Yes, every Urbania rental comes with a professional, courteous driver who ensures safety, punctuality, and a smooth journey for all passengers.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, cleaned, and maintained to ensure maximum safety, hygiene, and comfort.'
  },
  {
    question: 'What is the cost of renting an Urbania in Pune?',
    answer: 'The rental cost depends on the duration of the trip, distance, and additional services. Contact Amruta Travels for a customized and transparent quote.'
  },
  {
    question: 'Can I customize pickup and drop-off points?',
    answer: 'Yes, we provide flexible pickup and drop-off options and can customize the route according to your schedule and travel plan.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania rental services in Pune?',
    answer: 'Amruta Travels provides well-maintained Urbania vehicles, professional drivers, transparent pricing, and dedicated support, ensuring a comfortable and premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Deshmukh',
    role: 'Corporate Manager, Pune',
    text: 'We used Urbania rental services for our team outing. The vehicle was spacious, clean, and very comfortable. The driver was professional and punctual. Excellent service from Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Ananya Patil',
    role: 'Event Coordinator, Pune',
    text: 'Booked an Urbania for a family trip. The vehicle was luxurious, the ride was smooth, and the driver was courteous. Highly recommend Amruta Travels for Urbania rentals!',
    rating: 5
  }
];


















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];









    return (
        <div>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/105.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniarentalservicepune;